import { Component } from '@angular/core';
import { TabPanelComponent } from '../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../core/panels/tab-panel/tab.component';
@Component({
  selector: 'app-tab-panel-design',
  imports: [TabPanelComponent, TabComponent],
  template: `
    <app-tab-panel>
      <app-tab label="First">
        <ng-template #content> First tab content </ng-template>
      </app-tab>
      <app-tab label="Second">
        <ng-template #content> Second tab content </ng-template>
      </app-tab>
    </app-tab-panel>
  `,
  styles: ``,
})
export class TabPanelDesignComponent {}
